export default "__VITE_ASSET__BqwUW1t8__"